import type { FunctionComponent } from "react"

import styles from "./Column.module.css"

type ColumnProps = {
  value: number
}

export const Column: FunctionComponent<ColumnProps> = props => {
  const { value } = props

  return (
    <div className={styles.wrapper}>
      <span className={styles.value}>{value}</span>
    </div>
  )
}
